import { renderToStaticMarkup } from "react-dom/server";

const processCitationsInAnswer = (
  text,
  citations,
  currentCitationCount = 0
) => {
  if (!text || !citations || citations.length === 0) {
    return text;
  }

  // Look for citation patterns [guid] in the text
  const parts = text.split(/\[([^\]]+)\]/g);

  const fragments = parts.map((part, index) => {
    if (index % 2 === 0) {
      return part;
    } else {
      // This part is a citation ID
      const citation = citations.find((c) => c.id === part);
      if (citation) {
        // Determine the target tab based on the content type
        const targetTab =
          citation.type === "video_section" ? "video" : "document";
        return renderToStaticMarkup(
          <a className="supContainer" title={citation.title || "Citation"}>
            <sup data-docid={part} data-target-tab={targetTab}>
              {citation.index}
            </sup>
          </a>
        );
      }
      return `[${part}]`; // Keep original if not found
    }
  });

  return fragments.join("");
};

export { processCitationsInAnswer };
